import { useTranslation } from 'react-i18next';

interface Props { isOpen: boolean; email?: string; onClose: () => void; }

export default function EmailVerificationModal({ isOpen, email, onClose }: Props) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex min-h-screen items-center justify-center bg-black/70 backdrop-blur-sm p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="verify-modal-title">
      <div className="w-full max-w-sm sm:max-w-md bg-gray-900 rounded-lg sm:rounded-xl shadow-2xl border border-pink-600/20">
        <div className="flex items-center justify-between px-5 sm:px-6 py-4 border-b border-gray-800">
          <h3 id="verify-modal-title" className="text-lg font-semibold text-white">{t('auth.verifyTitle')}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white px-2 py-1 rounded">✕</button>
        </div>
        <div className="p-5 sm:p-6 space-y-3 text-gray-300">
          <p>{t('auth.verifyDescription', { email })}</p>
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-400">
            <li>{t('auth.verifyStep1')}</li>
            <li>{t('auth.verifyStep2')}</li>
          </ul>
          <button onClick={onClose} className="mt-2 w-full bg-pink-600 hover:bg-pink-700 text-white font-semibold rounded-md py-2">{t('auth.verifyClose')}</button>
        </div>
      </div>
    </div>
  );
}


